import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-fileswhofor',
    templateUrl: './fileswhofor.component.html',
    styleUrls: ['./fileswhofor.component.css'],
    standalone: false
})
export class FileswhoforComponent {
  @Output() goToReciepent = new EventEmitter();
  selectType(family = false, name = '') {   
    this.goToReciepent.emit({ family, name });
  }
}
